import React from "react";
import Image from "next/image";
import styles from "./Login.module.less";
import logo from "@aspen/assets/images/aspen_logo_white.webp";
import bgImage from "@aspen/assets/images/image_service_bg@2x.png";
import { i18nUtil } from "@aspen/libs";
import LanguageSwitch from "./LanguageSwitch";
import clsx from "clsx";

export const LoginLayoutSAS = WrappedComponent => {
  const LoginSAS = props => {
    const intl = i18nUtil.t();

    return (
      <section
        className={clsx(styles.login, "login")}
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
        }}>
        <LanguageSwitch />
        <div className={styles.main}>
          <div className={styles.mainContainer}>
            <section className={styles.leftBriefBlue}>
              <span className={styles.logo}>
                <Image unoptimized src={logo} alt="logo" />
              </span>
              <p className={styles.title}>{intl["login.title.SAS"]}</p>
            </section>
            <WrappedComponent {...props} />
          </div>
        </div>
      </section>
    );
  };

  return LoginSAS;
};
